































































































































































































































































































































































































































































































































































































































































































































































import "bootstrap-vue";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import store from "@/services/store";
import {
    AppDataClass,
    formatAmount,
    IAbp,
    IContractAppDetailResponse,
    IGu,
    IPaymentRow,
    IPpr,
    IPrg,
    IRegion,
    ISpf,
    ValidationErrors,
} from "./form-409-types";

@Component({
    name: "appCard",
    components: {
        multiselect: Multiselect,
        DatePicker,
    },
})
export default class Form409AppCard extends Vue {
    $refs!: {
        appCard: HTMLFormElement;
    };
    @Prop({
        required: true,
        default: () => new AppDataClass(),
    })
    private app!: AppDataClass;
    @Prop({
        type: String,
        default: "view",
        validator: (value: string) =>
            ["view", "edit", "create"].includes(value),
    })
    private mode!: string;
    @Prop({ required: true }) save!: boolean;
    @Prop({ required: true }) validationErrors!: ValidationErrors;
    private localValidationErrors: any = { ...this.validationErrors };

    @Prop({ required: true }) private guOptions!: IGu[];
    private localGuOptions: IGu[] = [...this.guOptions];
    @Prop({ required: true, default: null }) private selectedGu!: any | null;

    @Prop({ required: true }) private abpOptions!: IAbp[];
    private localAbpOptions: IAbp[] = [...this.abpOptions];
    @Prop({ required: true, default: null }) private selectedAbp!: any | null;

    @Prop({ required: true }) private prgOptions!: IPrg[];
    private localPrgOptions: IPrg[] = [...this.prgOptions];
    @Prop({ required: true, default: null }) private selectedPrg!: any | null;

    @Prop({ required: true, default: () => [] })
    private regionOptions!: IRegion[];
    private localRegionOptions: IRegion[] = [...this.regionOptions];
    @Prop({ required: true, default: null }) private selectedRegion!:
        | any
        | null;

    @Prop({ required: true }) private pprOptions!: IPpr[];
    private localPprOptions: IPpr[] = [...this.pprOptions];
    @Prop({ required: true, default: () => [] })
    private selectedPpr!: any | null;

    @Prop({ required: true }) private spfOptions!: ISpf[];
    private localSpfOptions: ISpf[] = [...this.spfOptions];
    @Prop({ required: true, default: () => [] }) private selectedSpf!:
        | any
        | null;

    private payments: IPaymentRow[] = [];
    @Prop({ default: () => [] })
    private initialPayments!: IPaymentRow[];
    @Prop({ default: () => [] })
    readonly originalAppPayments!: IPaymentRow[];
    @Prop({ default: null })
    private defaultPayDate!: Date | null;
    @Prop({ default: false })
    private nomZaInIisk!: boolean;
    @Prop({ default: null })
    private binding!: {
        bound: boolean;
        year?: number;
        project?: string;
        year_rows_total?: number;
        rows_after_remove_all?: number;
        rows_after_delete_by_id?: { [id: string]: number };
    } | null;
    private deletedDbIds: number[] = [];
    private numAppSuffix: string = "";
    private numAppGz: boolean = false;
    private isReturnInvoice: boolean = false;
    private invoiceNumSuffix: string = "";
    private isShowDelModal: boolean = false;
    private obligationAmountDisplay: string = "";
    private isObligationEditing: boolean = false;

    get paymentList(): IPaymentRow[] {
        return this.payments;
    }

    private formatDisplayDate(date: Date | null): string {
        if (!date) return "";
        if (!(date instanceof Date) || isNaN(date.getTime())) return "";
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    }

    private formatNumber(value: number | null | undefined): string {
        if (value === null || value === undefined) return "";

        return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    private onObligationAmountInput() {
        this.isObligationEditing = true;
        let value = this.obligationAmountDisplay || "";

        value = value.replace(/\s/g, "");
        value = value.replace(/[^\d.,]/g, "");
        value = value.replace(/,/g, ".");

        const dotIndex = value.indexOf(".");
        if (dotIndex !== -1) {
            const beforeDot = value.slice(0, dotIndex + 1);
            const afterDot = value.slice(dotIndex + 1).replace(/\./g, "");
            value = beforeDot + afterDot;
        }

        const [rawInt = "", rawDecimal = ""] = value.split(".");
        const decimal = rawDecimal.slice(0, 2);
        const normalizedInt = rawInt.replace(/^0+(?=\d)/, "") || "0";
        const formattedInt = normalizedInt.replace(
            /\B(?=(\d{3})+(?!\d))/g,
            " "
        );

        this.obligationAmountDisplay = value.includes(".")
            ? `${formattedInt}.${decimal}`
            : formattedInt;

        const numericString =
            decimal.length > 0 ? `${normalizedInt}.${decimal}` : normalizedInt;
        this.app.obligationAmount = Number(numericString) || 0;

        this.clearValidationError("appData.obligationAmount");
    }

    private onObligationAmountBlur() {
        this.isObligationEditing = false;
        this.obligationAmountDisplay = formatAmount(this.app.obligationAmount);
    }

    private onAmountInput(item: any, index: number) {
        let value = item.formattedPayAmount || "";

        value = value.replace(/\s/g, "");
        value = value.replace(/[^\d.,]/g, "");
        value = value.replace(/,/g, ".");
        const isNegative = value.startsWith("-");
        if (isNegative) value = "-" + value;

        const dotIndex = value.indexOf(".");

        if (dotIndex !== -1) {
            const beforeDot = value.slice(0, dotIndex + 1);
            const afterDot = value.slice(dotIndex + 1).replace(/\./g, "");

            value = beforeDot + afterDot;
        }

        const [rawInt = "", rawDecimal = ""] = value.split(".");

        const decimal = rawDecimal.slice(0, 2);

        const normalizedInt = rawInt.replace(/^0+(?=\d)/, "") || "0";

        const formattedInt = normalizedInt.replace(
            /\B(?=(\d{3})+(?!\d))/g,
            " "
        );

        item.formattedPayAmount = value.includes(".")
            ? `${formattedInt}.${decimal}`
            : formattedInt;

        const numericString =
            decimal.length > 0 ? `${normalizedInt}.${decimal}` : normalizedInt;

        const absAmount = Number(numericString);
        item.payAmount = item.isReturnInvoice ? -absAmount : absAmount;

        if (item.isReturnInvoice && absAmount > 0) {
            item.formattedPayAmount = value.includes(".")
                ? `-${formattedInt}.${decimal}`
                : `-${formattedInt}`;
        }

        this.clearValidationError(`item[${index}].payAmount`);
    }

    private onAmountBlur(item: any) {
        item.formattedPayAmount = formatAmount(item.payAmount);
    }

    private blockInvalidKeys(event: KeyboardEvent) {
        const allowedKeys = [
            "Backspace",
            "Delete",
            "ArrowLeft",
            "ArrowRight",
            "Tab",
        ];

        const char = event.key;

        if (allowedKeys.includes(char)) return;

        if (event.ctrlKey || event.metaKey) return;

        if (/\d/.test(char)) return;

        if (char === "." || char === ",") return;
        if (
            char === "-" &&
            (event.target as HTMLInputElement).selectionStart === 0
        )
            return;

        event.preventDefault();
    }

    private allowDigitsSymbols(event: KeyboardEvent) {
        const char = event.key;
        const input = event.target as HTMLInputElement;

        const allowedKeys = [
            "Backspace",
            "Delete",
            "ArrowLeft",
            "ArrowRight",
            "Tab",
        ];

        if (!/[a-zA-Zа-яА-Я\d_\/-]/.test(char) && !allowedKeys.includes(char)) {
            event.preventDefault();
            return;
        }
    }

    private allowOnlyNumbers(event: KeyboardEvent) {
        const char = event.key;
        const input = event.target as HTMLInputElement;

        const allowedKeys = [
            "Backspace",
            "Delete",
            "ArrowLeft",
            "ArrowRight",
            "Tab",
        ];

        if (!/[\d]/.test(char) && !allowedKeys.includes(char)) {
            event.preventDefault();
            return;
        }
    }

    private pasteDigitsInto(
        event: ClipboardEvent,
        field: "binSupplier" | "numNotify",
        maxLength: number,
        validationKey: string
    ) {
        const pasted = event.clipboardData?.getData("text") ?? "";
        const digitsOnly = pasted.replace(/\D/g, "").slice(0, maxLength);
        const input = event.target as HTMLInputElement;
        const start = input.selectionStart ?? 0;
        const end = input.selectionEnd ?? 0;
        const current = (this.app[field] as string) ?? "";
        const next = (
            current.slice(0, start) +
            digitsOnly +
            current.slice(end)
        ).slice(0, maxLength);
        (this.app[field] as any) = next;
        this.clearValidationError(validationKey);
    }

    private onBinSupplierPaste(event: ClipboardEvent) {
        this.pasteDigitsInto(event, "binSupplier", 12, "appData.binSupplier");
    }

    private onNumNotifyPaste(event: ClipboardEvent) {
        this.pasteDigitsInto(event, "numNotify", 7, "appData.numNotify");
    }

    private onObligationPaste(event: ClipboardEvent) {
        const pasted = event.clipboardData?.getData("text") ?? "";
        const cleaned = pasted.replace(/[^\d.,]/g, "");
        (event.target as HTMLInputElement).value = cleaned;
        this.obligationAmountDisplay = cleaned;
        this.onObligationAmountInput();
    }

    private onPayAmountPaste(event: ClipboardEvent, item: any, index: number) {
        const pasted = event.clipboardData?.getData("text") ?? "";
        const cleaned = pasted.replace(/[^\d.,]/g, "");
        (event.target as HTMLInputElement).value = cleaned;
        item.formattedPayAmount = cleaned;
        this.onAmountInput(item, index);
    }

    private trimField(field: keyof AppDataClass) {
        const value = this.app[field];
        if (typeof value === "string") {
            (this.app[field] as string) = value.trim().replace(/\s+/g, " ");
        }
    }

    private charCount(value: string | null, max: number): string {
        const count = value?.length || 0;
        return `${count} / ${max}`;
    }

    private isAtLimit(value: string | null, max: number): boolean {
        return (value?.length || 0) >= max;
    }

    get currentRegion() {
        const fromApp =
            this.localRegionOptions.find(
                (option: any) => option.text === this.app?.budgetRegion
            ) || null;

        return this.isCreatable
            ? this.selectedRegion || fromApp
            : fromApp || this.selectedRegion || null;
    }
    set currentRegion(value: any | null) {
        this.$emit("update:selectedRegion", value);
    }

    get currentAbp() {
        const fromApp =
            this.localAbpOptions.find(
                (option: any) => option.text === this.app?.abp
            ) || null;

        return this.isCreatable
            ? this.selectedAbp || fromApp
            : fromApp || this.selectedAbp || null;
    }

    set currentAbp(value: any | null) {
        this.$emit("update:selectedAbp", value);
    }

    get currentGu() {
        const textField = this.curLanguage === "kk" ? "text_kk" : "text";

        const fromApp =
            this.localGuOptions.find(
                (option: any) => option[textField] === this.app?.gu
            ) || null;

        return this.isCreatable
            ? this.selectedGu || fromApp
            : fromApp || this.selectedGu || null;
    }

    set currentGu(value: any | null) {
        this.$emit("update:selectedGu", value);
    }

    get currentPrg() {
        const fromApp =
            this.localPrgOptions.find(
                (option) => option.text === this.app?.prg
            ) || null;

        return this.isCreatable
            ? this.selectedPrg || fromApp
            : fromApp || this.selectedPrg || null;
    }

    set currentPrg(value: any | null) {
        this.$emit("update:selectedPrg", value);
    }

    get currentSpf() {
        const fromApp =
            this.localSpfOptions.find(
                (option) => String(option.spf) === String(this.app?.spf)
            ) || null;

        return this.isCreatable
            ? this.selectedSpf || fromApp
            : fromApp || this.selectedSpf || null;
    }

    set currentSpf(value: any | null) {
        this.$emit("update:selectedSpf", value);
    }

    get curLanguage() {
        return this.$i18n.locale || "ru";
    }

    get isViewable() {
        return this.mode === "view";
    }

    get isEditable() {
        return this.mode === "edit";
    }

    get isCreatable() {
        return this.mode === "create";
    }

    get userId() {
        return store.getters.user_uuid;
    }

    public async created() {
        this.$watch("regionOptions", (newOptions: any) => {
            this.localRegionOptions = [...newOptions];
        });
        this.$watch("abpOptions", (newOptions: any) => {
            this.localAbpOptions = [...newOptions];
        });

        this.$watch("prgOptions", (newOptions: any) => {
            this.localPrgOptions = [...newOptions];
        });
        this.$watch("pprOptions", (newOptions: any) => {
            this.localPprOptions = [...newOptions];
        });
        this.$watch("guOptions", (newOptions: any) => {
            this.localGuOptions = [...newOptions];
        });
        this.$watch("spfOptions", (newOptions: any) => {
            this.localSpfOptions = [...newOptions];
        });
        this.$watch("validationErrors", (newErrors: any) => {
            this.localValidationErrors = { ...newErrors };
        });
        this.$watch(
            () => this.app.obligationAmount,
            (newVal) => {
                if (!this.isObligationEditing) {
                    this.obligationAmountDisplay = formatAmount(newVal);
                }
            },
            { immediate: true }
        );

        this.$watch(
            "initialPayments",
            (newPayments: IPaymentRow[]) => {
                this.payments = newPayments.map((p) => {
                    const returnSuffix = this.getReturnInvoiceSuffix();
                    const normalPrefix = this.getGuPrefix;

                    let isReturn = false;
                    let suffix = "";

                    if (
                        p.invoiceNum.startsWith("ВР") &&
                        p.invoiceNum.endsWith(returnSuffix)
                    ) {
                        isReturn = true;
                        suffix = p.invoiceNum.slice(2, -returnSuffix.length);
                    } else if (p.invoiceNum.startsWith(normalPrefix)) {
                        suffix = p.invoiceNum.slice(normalPrefix.length);
                    }

                    return {
                        ...p,
                        isReturnInvoice: isReturn,
                        invoiceNumSuffix: suffix,
                    };
                });
                this.deletedDbIds = [];
            },
            { immediate: true }
        );
        this.$watch(
            () => [this.app.obligationAmount, this.totalPayAmount],
            () => {
                this.validateObligation();
            },
            { immediate: true }
        );
        this.$watch(
            "app.numApp",
            (newVal: string) => {
                if (!newVal) return;

                const prefix = this.getGuPrefix;
                if (newVal.startsWith(prefix)) {
                    let rest = newVal.slice(prefix.length);
                    if (rest.endsWith("-GZ")) {
                        this.numAppGz = true;
                        rest = rest.slice(0, -3);
                    } else {
                        this.numAppGz = false;
                    }
                    this.numAppSuffix = rest;
                }
            },
            { immediate: true }
        );
        this.$watch(
            "payments",
            (newPayments: IPaymentRow[]) => {
                const dates = newPayments
                    .map((p) => p.payDate)
                    .filter(
                        (d): d is Date =>
                            d instanceof Date && !isNaN(d.getTime())
                    );

                if (dates.length > 0) {
                    const maxDate = new Date(
                        Math.max(...dates.map((d) => d.getTime()))
                    );
                    this.$emit("max-pay-date-changed", maxDate);
                }
            },
            { deep: true }
        );
        this.$watch("app.numNotify", () => {
            this.refreshInvoices();
        });
    }

    public mounted() {}

    private isDateInRange(date: Date, min: Date, max: Date): boolean {
        const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        const minD = new Date(min.getFullYear(), min.getMonth(), min.getDate());
        const maxD = new Date(max.getFullYear(), max.getMonth(), max.getDate());

        return d >= minD && d <= maxD;
    }

    private disableContractDate = (dogDate: Date | null): boolean => {
        if (!dogDate) return true;

        const min = new Date(2018, 0, 1);
        const max = new Date();
        max.setMonth(max.getMonth() + 1);

        return !this.isDateInRange(dogDate, min, max);
    };

    private disableRegDate = (regDate: Date | null): boolean => {
        if (!regDate || !this.app?.dateContract) return true;

        // при привязке к проекту менять год даты доп.соглашения нельзя (день и месяц можно)
        if (
            this.app.hasProject &&
            this.app.boundRegYear !== null &&
            regDate.getFullYear() !== this.app.boundRegYear
        ) {
            return true;
        }

        const min = new Date(this.app.dateContract);
        const max = new Date();
        max.setMonth(max.getMonth() + 1);

        return !this.isDateInRange(regDate, min, max);
    };

    private disablePayDate = (payDate: Date | null): boolean => {
        if (!payDate) return true;

        const min = new Date(2018, 0, 1);
        const max = new Date();
        max.setDate(max.getDate() + 7);

        if (this.app?.dateReg) {
            const dateReg = new Date(this.app.dateReg);

            dateReg.setHours(0, 0, 0, 0);

            const currentPayDate = new Date(payDate);
            currentPayDate.setHours(0, 0, 0, 0);

            if (currentPayDate < dateReg) return true;
        }

        return !this.isDateInRange(payDate, min, max);
    };

    private formatDateLocal(date: Date | null): string | null {
        if (!date) return null;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }

    get totalPayAmount(): string {
        const total = this.payments.reduce(
            (sum, p) => sum + Number(p.payAmount ?? 0),
            0
        );

        return total
            .toLocaleString("ru-RU", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })
            .replace(",", ".");
    }

    private idCounter = 0;

    private generateUniqueId(): number {
        return Date.now() + this.idCounter++;
    }

    private addNewPayment() {
        this.payments.push({
            id: this.generateUniqueId(),
            payDate: null,
            payAmount: null,
            invoiceNum: "",
            source: "edit",
            isReturnInvoice: false,
            invoiceNumSuffix: "",
            formattedPayAmount: "",
        });
    }

    private showDeleteModal() {
        this.isShowDelModal = true;
    }

    private get lastPaymentMessage(): string {
        return String(
            this.$t(
                "modules.budget_execution_monitoring.editor_409.messages.LAST_PAYMENT_IN_YEAR",
                {
                    year: this.binding?.year,
                    project: this.binding?.project,
                }
            )
        );
    }

    private get removeAllBlocked(): boolean {
        return (
            !!this.binding?.bound && this.binding.rows_after_remove_all === 0
        );
    }

    private deleteReduction(dbId: number): number {
        const total = this.binding?.year_rows_total ?? 0;
        const after = this.binding?.rows_after_delete_by_id?.[String(dbId)];
        return after === undefined ? 1 : total - after;
    }

    // строки договора за год (с учётом удалений и новых платежей)
    private get yearRowsNow(): number {
        const newRows = this.payments.filter((p) => !p.dbId).length;
        const reduced = this.deletedDbIds.reduce(
            (sum, id) => sum + this.deleteReduction(id),
            0
        );
        return (this.binding?.year_rows_total ?? 0) - reduced + newRows;
    }

    // корзина блокируется, если после удаления платежа договор за год останется без строк
    private isRowDeleteBlocked(item: IPaymentRow): boolean {
        if (!this.binding?.bound || !item.dbId) {
            return false;
        }
        return this.yearRowsNow - this.deleteReduction(item.dbId) < 1;
    }

    private get canRemoveAll(): boolean {
        // кнопку отобр если в заявке есть хотя бы один платеж edit
        return this.payments.some((p) => p.source === "edit");
    }

    private async removeAllApps() {
        const editPayments = this.payments.filter(
            (p) => p.source === "edit" && p.dbId
        );
        this.payments = [];

        if (editPayments.length === 0) {
            return;
        }

        this.deletedDbIds.push(...editPayments.map((p) => p.dbId!));
        this.$emit("remove-all");
    }

    private deletePayment(index: number) {
        const deleted = this.payments[index];

        if (deleted.source === "edit" && deleted.dbId) {
            this.deletedDbIds.push(deleted.dbId);
        }
        this.payments.splice(index, 1);
    }

    private isPaymentDirty(p: any): boolean {
        if (!p.dbId) return true;

        const original = this.originalAppPayments.find(
            (x) => x.dbId === p.dbId
        );

        if (!original) return true;

        const normalizeDate = (d: any) => (d ? new Date(d).getTime() : null);

        return (
            Number(p.payAmount ?? 0) !== Number(original.payAmount ?? 0) ||
            (p.invoiceNum ?? "").trim() !==
                (original.invoiceNum ?? "").trim() ||
            normalizeDate(p.payDate) !== normalizeDate(original.payDate)
        );
    }

    getFormData(headerChanged: boolean) {
        const pick = (rowValue: any, filterValue: any) =>
            this.isCreatable
                ? filterValue ?? rowValue
                : rowValue ?? filterValue;

        const abp = String(
            pick(this.app?.abp, this.selectedAbp?.abp) ?? ""
        ).padStart(3, "0");
        const prg = String(
            pick(this.app?.prg, this.selectedPrg?.prg) ?? ""
        ).padStart(3, "0");
        const ppr = String(
            pick(this.app?.ppr, this.selectedPpr?.ppr) ?? ""
        ).padStart(3, "0");
        const func = `${abp}${prg}${ppr}`;

        const spfCode = pick(this.app?.spf, this.selectedSpf?.spf) ?? "";
        const espk = String(spfCode).padStart(6, "0");
        const kodTpk = pick(this.app?.budgetRegion, this.selectedRegion?.code);
        const gu = pick(this.app?.gu, this.selectedGu?.code);
        const typeBudjet = this.currentGu?.budget_type ?? "";

        const mapPayment = (payment: any) => ({
            row_no: this.payments.indexOf(payment) + 1,
            ...(payment.source !== "iisk" &&
                payment.dbId && { id: payment.dbId }),

            dt_reg: this.formatDateLocal(this.app.dateReg),
            nom_za: this.app.numApp,
            nom_dog: this.app.numContract,
            dt_dog: this.formatDateLocal(this.app.dateContract),
            rnn_supplier: this.app.binSupplier,
            supplier: this.app.supplier,
            nom_uved: this.app.numNotify,
            item_description: this.app.description,
            summa_dog: this.app.obligationAmount,
            kod_tpk: kodTpk,
            gu: gu,
            func: func,
            espk: espk,
            pay_date: this.formatDateLocal(payment.payDate),
            pay_amount: payment.payAmount,
            invnum: payment.invoiceNum ?? "",
            type_budjet: typeBudjet,
            user_id: this.userId,
        });

        const validPayments = this.payments;

        let rowsToSave: any[] = [];

        if (headerChanged) {
            rowsToSave = validPayments.map(mapPayment);
        } else {
            rowsToSave = validPayments
                .filter((p) => this.isPaymentDirty(p))
                .map(mapPayment);
        }
        return {
            rows: rowsToSave,
            deletedDbIds: this.deletedDbIds,
        };
    }

    private hasInvalidChars(value: string | null | undefined): boolean {
        const INVALID_CONTROL_CHARS = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/;

        return typeof value === "string" && INVALID_CONTROL_CHARS.test(value);
    }

    private validatePaymentList(): boolean {
        const errors: ValidationErrors = {};

        const t = (key: string, params?: object) =>
            String(
                this.$t(
                    `modules.budget_execution_monitoring.editor_409.messages.${key}`,
                    params
                )
            );
        const validateError = t("validate_error");

        this.paymentList.forEach((item, index) => {
            const baseKey = `item[${index}]`;
            const n = index + 1;

            const payDateKey = `${baseKey}.payDate`;
            const payAmountKey = `${baseKey}.payAmount`;
            const invoiceKey = `${baseKey}.invoiceNum`;
            let errorMessage = "";

            if (item.source === "edit" && !item.payDate) {
                errorMessage = t("fill_pay_date_in_row", { n });
                errors[payDateKey] = errorMessage;
                this.makeToast("warning", errorMessage, validateError);
            }

            const amount = Number(item.payAmount);

            if (
                item.source === "edit" &&
                (item.payAmount === null ||
                    item.payAmount === undefined ||
                    isNaN(item.payAmount))
            ) {
                errorMessage = t("fill_sum_pay_in_row", { n });
                errors[payAmountKey] = errorMessage;

                this.makeToast("warning", errorMessage, validateError);
            } else if (
                isNaN(amount) ||
                (item.isReturnInvoice ? amount >= 0 : amount < 0)
            ) {
                errorMessage = item.isReturnInvoice
                    ? t("sum_refund_err_ng_msg", { n })
                    : t("sum_refund_err_ps_msg", { n });
                errors[payAmountKey] = errorMessage;
                this.makeToast("warning", errorMessage, validateError);
            }

            if (
                item.source === "edit" &&
                item.isReturnInvoice &&
                !item.invoiceNumSuffix?.trim()
            ) {
                errorMessage = t("fill_invoice_ref_err_msg", { n });
                errors[invoiceKey] = errorMessage;
                this.makeToast("warning", errorMessage, validateError);
            }

            if (
                item.source === "edit" &&
                !item.invoiceNumSuffix?.trim() &&
                item.payAmount !== 0
            ) {
                errorMessage = t("fill_invoice_err_msg", { n });
                errors[invoiceKey] = errorMessage;
                this.makeToast("warning", errorMessage, validateError);
            }

            if (
                item.source === "edit" &&
                this.hasInvalidChars(item.invoiceNumSuffix)
            ) {
                errorMessage = t("invalid_symbol_invoice_err_msg", { n });
                errors[invoiceKey] = errorMessage;
                this.makeToast("warning", errorMessage, validateError);
            }

            if (item.source === "edit" && item.invoiceNum?.length > 26) {
                errorMessage = t("limit_cnt_symb_invoice_err_msg", { n });
                errors[invoiceKey] = errorMessage;
                this.makeToast("warning", errorMessage, validateError);
            }

            if (item.source === "edit" && item.payDate && this.app?.dateReg) {
                const payDateKey = `${baseKey}.payDate`;

                const payDate = new Date(item.payDate);
                payDate.setHours(0, 0, 0, 0);

                const regDate = new Date(this.app.dateReg);
                regDate.setHours(0, 0, 0, 0);

                if (payDate < regDate) {
                    errorMessage = t("pay_date_reg_date_err_msg", { n });
                    errors[payDateKey] = errorMessage;
                    this.makeToast("warning", errorMessage, validateError);
                }

                const regYear = regDate.getFullYear();
                const payYear = payDate.getFullYear();

                if (payYear !== regYear) {
                    errorMessage = t("pay_year_reg_year_err_msg", { n });
                    errors[payDateKey] = errorMessage;
                    this.makeToast("warning", errorMessage, validateError);
                }
            }
        });

        this.localValidationErrors = errors;
        this.$emit("validation-complete", errors);
        return Object.keys(errors).length === 0;
    }

    markInvoiceError(n: number, message: string) {
        const errors = { ...this.localValidationErrors };
        errors[`item[${n - 1}].invoiceNum`] = message;
        this.localValidationErrors = errors;
        this.$emit("validation-complete", errors);
    }

    // подсветка payDate, payAmount или invoiceNum
    markRowError(n: number, field: string, message: string) {
        const errors = { ...this.localValidationErrors };
        errors[`item[${n - 1}].${field}`] = message;
        this.localValidationErrors = errors;
        this.$emit("validation-complete", errors);
    }

    markPayDateError(n: number, message: string) {
        const errors = { ...this.localValidationErrors };
        errors[`item[${n - 1}].payDate`] = message;
        this.localValidationErrors = errors;
        this.$emit("validation-complete", errors);
    }

    private isExistPaymentList(): boolean {
        if (!this.paymentList || this.paymentList.length === 0) {
            const t = (key: string) =>
                String(
                    this.$t(
                        `modules.budget_execution_monitoring.editor_409.messages.${key}`
                    )
                );
            const validateError = t("validate_error");
            const message = t("saving_without_payment_err_msg");

            this.makeToast("warning", message, validateError);

            this.localValidationErrors = {
                paymentList: message,
            };

            this.$emit("validation-complete", this.localValidationErrors);

            return false;
        }

        return true;
    }

    private validateObligation() {
        const obligation =
            Math.round(Number(this.app?.obligationAmount || 0) * 100) / 100;
        const total =
            Math.round(
                this.payments.reduce(
                    (sum, p) => sum + Number(p.payAmount ?? 0),
                    0
                ) * 100
            ) / 100;

        if (!this.validationErrors) {
            this.validationErrors = {};
        }

        if (obligation < total) {
            this.validationErrors["appData.obligationAmount"] = String(
                this.$t(
                    "modules.budget_execution_monitoring.editor_409.messages.conflict_sum_dog_sum_payment"
                )
            );
        } else {
            delete this.validationErrors["appData.obligationAmount"];
        }
    }

    private resetValidationErrors() {
        Object.keys(this.validationErrors || {}).forEach((key) => {
            this.$set(this.validationErrors, key, undefined);
        });
    }

    private clearValidationError(key: string) {
        if (this.validationErrors?.[key]) {
            this.$delete(this.validationErrors, key);
        }

        if (this.localValidationErrors?.[key]) {
            this.$delete(this.localValidationErrors, key);
        }
    }

    private buildNumApp(): string {
        const suffix = this.numAppSuffix.replace(/\s/g, "");
        const gz = this.numAppGz ? "-GZ" : "";
        return `${this.getGuPrefix}${suffix}${gz}`;
    }

    private onNumAppInput() {
        this.numAppSuffix = this.numAppSuffix.replace(/\s/g, "");
        this.app.numApp = this.buildNumApp();
        this.clearValidationError("appData.numApp");
    }

    public isNumAppValid(): boolean {
        return !!this.numAppSuffix?.trim();
    }

    private onNumAppGzChange() {
        this.app.numApp = this.buildNumApp();
    }

    private get yearShort(): string {
        if (!this.app?.dateReg) return "";
        const date = new Date(this.app.dateReg);
        if (isNaN(date.getTime())) return "";
        return String(date.getFullYear()).slice(-2);
    }

    private get getGuPrefix(): string {
        const gu = this.app.gu || this.currentGu?.code || "";
        return `${gu}/${this.yearShort}-`;
    }

    private getReturnInvoiceSuffix(): string {
        const notify = this.app.numNotify ?? "";
        return `-${notify}Д`;
    }

    parseInvoice(row: IContractAppDetailResponse) {
        const invoice = row.invnum ?? "";

        const returnSuffix = `-${this.app.numNotify}Д`;

        // Возврат
        if (invoice.startsWith("ВР")) {
            return {
                isReturnInvoice: true,
                invoiceNumSuffix: invoice
                    .replace("ВР", "")
                    .replace(returnSuffix, ""),
                invoiceNum: invoice,
            };
        }

        // Обычный счет
        const prefix = this.getGuPrefix;

        return {
            isReturnInvoice: false,
            invoiceNumSuffix: invoice.replace(prefix, ""),
            invoiceNum: invoice,
        };
    }

    private buildInvoiceNum(item: IPaymentRow): string {
        if (!item.invoiceNumSuffix?.trim() || !this.app.numNotify) return "";
        if (item.isReturnInvoice) {
            return `ВР${item.invoiceNumSuffix}${this.getReturnInvoiceSuffix()}`;
        } else {
            return `${this.getGuPrefix}${item.invoiceNumSuffix}`;
        }
    }

    private onInvoiceSuffixInput(item: IPaymentRow, index: number) {
        item.invoiceNumSuffix = item.invoiceNumSuffix.replace(/\s/g, "");
        item.invoiceNum = this.buildInvoiceNum(item);
        this.clearValidationError(`item[${index}].invoiceNum`);
    }

    private onReturnInvoiceChange(item: IPaymentRow) {
        item.payAmount = item.isReturnInvoice
            ? -Math.abs(item.payAmount || 0)
            : Math.abs(item.payAmount || 0);

        item.formattedPayAmount = this.formatNumber(item.payAmount);

        item.invoiceNum = this.buildInvoiceNum(item);
        item.invoiceNumSuffix = "";
    }

    private refreshInvoices() {
        this.paymentList.forEach((item) => {
            if (item.source !== "iisk") {
                item.invoiceNum = this.buildInvoiceNum(item);
            }
        });
    }

    resetForm() {
        this.numAppSuffix = "";
        this.numAppGz = false;
    }

    makeToast(variant: string | undefined, tostbody: any, title: string) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: "b-toaster-top-center",
            autoHideDelay: 4000,
            solid: true,
            appendToast: true,
        });
    }
}
